import { FieldArray } from 'redux-form';

const ValidatedFormFieldArray = FieldArray;

export default ValidatedFormFieldArray;
